export const twitch_messages = [
  'haHAA',
  'CiGrip',
  'PopNemo',
  'PogChamp',
  'bttvNice',
  'ariW wave',
  'DinoDance',
  'CruW salute',
  'c! PogChamp',
  'LUL LUL LUL',
  'CandianRage',
  'CatBag kitty!',
  '<3 good times',
  'catJAM vibing',
  'DuckerZ quack',
  ':tf: trollface',
  'haHAA good one',
  "HSWP let's go!",
  'DxCat claws out',
  'ConcernDoge hmm',
  'BroBalt nice one',
  'VoHiYo everyone!',
  'LuL that was funny',
  'Kappa just kidding',
  'FBCatch nice grab!',
  'cvHazmat stay safe',
  'CookieTime nom nom',
  'LuL that was funny',
  'CruW crew assembled',
  'GlitchCat GlitchCat',
  'CoolCat staying calm',
  'bUrself be yourself!',
  'catJAM catJAM catJAM',
  'HSWP here we go again',
  'Shush moment incoming',
  'duDudu rhythm section',
  ':tf: face palm moment',
  'duDudu rhythm section',
  'HSWP here we go again',
  'PunchTrees PunchTrees',
  'SSSsss Minecraft time',
  'KappaPride represent!',
  'haHAA that joke though',
  'DoritosChip snack time',
  'DoritosChip snack time',
  'asexualPride represent',
  'duDudu dancing on beat',
  'FBBlock defensive play!',
  'ariW waving at everyone',
  'PopNemo finding our way',
  'ariW waving at everyone',
  'TheIlluminati confirmed',
  'SSSsss slithering vibes',
  'GayPride celebrate love',
  'BloodTrail hunting time',
  'TheIlluminati confirmed',
  "LUL can't stop laughing",
  'HypeCheer clap clap clap',
  'DuckerZ quacking in chat',
  'Wait for it... PogChamp!',
  'HypeCheer clap clap clap',
  'KPOPTT music to our ears',
  'FrogPonder thinking frog',
  "IntersexPride we're here",
  'KappaPride be proud Kappa',
  'cvHazmat suit up for this',
  'BrainSlug giving me ideas',
  'KappaPride be proud Kappa',
  'This music is fire catJAM',
  'I just followed! PogChamp',
  'MrDestructoid robot vibes',
  'BroBalt brotherhood moment',
  'VoHiYo greetings from chat',
  'PogChamp PogChamp PogChamp',
  'DxCat meow meow KomodoHype',
  'Squid1 Squid2 Squid3 Squid4',
  'KomodoHype the hype is real',
  'DarkMode gang where you at?',
  'Wait what just happened? D:',
  'TakeNRG infinite energy NRG',
  'CookieTime break time snack',
  'The dedication is real here',
  'PopCorn watching this unfold',
  'CandianRage maple syrup fury',
  'PopCorn watching this unfold',
  'LesbianPride strong together',
  'DinoDance DinoDance DinoDance',
  'TakeNRG this energy is unreal',
  'Everyone gets hype! HypeCheer',
  'CiGrip strong grip on the game',
  'CoolCat no stress allowed here',
  'BisexualPride all love matters',
  'GenderFluidPride freedom to be',
  'DarkMode gang in here DarkMode',
  "HypeFail oops that didn't work",
  'HypePopcorn this is the moment',
  'ConcernDoge is everything okay?',
  'BloodTrail following the leader',
  'This is so wholesome AngelThump',
  'ImGlitch technical difficulties',
  'Anyone else eating? DoritosChip',
  'PixelBob retro vibes with Kappa',
  'SoonerLater catch you next time',
  'imGlitch glitchy but we love it',
  'KomodoHype the energy is crazy!',
  'NonbinaryPride beyond the binary',
  'PansexualPride love is universal',
  'This community is the best Kappa',
  'BrainSlug with the big brain play',
  'TransgenderPride living authentic',
  'AngelThump wholesomeness incoming',
  'GlitchCat imGlitch what happened?',
  'CrreamAwk that was awkward VoHiYo',
  'IronmouseLuv appreciate the stream',
  'PunchTrees minecraft mode activated',
  'The skill on display here is unreal',
  'LesbianPride GayPride BisexualPride',
  'PogChamp PogChamp PogChamp PogChamp',
  "TwitchUnity we're all here for this",
  'This is absolutely insane KomodoHype',
  'Never seen anything like this before',
  'Vibing with cat-shaped avatars catJAM',
  'EarthDay appreciation for this stream',
  "TheIlluminati knows something we don't",
  "Shush they're about to do something big",
  'Can we appreciate this moment? PogChamp',
  'MrDestructoid destroying the competition',
  'AsexualPride IntersexPride GenderFluidPride',
  'TransgenderPride PansexualPride NonbinaryPride',
];

export const youtube_messages = [
  ':ytg: Keep it up!',
  ':yt: YouTube hype!',
  ':gar: Amazing as always!',
  'No words, just :awesome:',
  'You got this! :yougotthis:',
  ':elbowbump: Great teamwork!',
  'Love this energy! :goodvibes:',
  'Just arrived! :hand-pink-waving:',
  'Great gameplay! :hand-yellow-nails:',
  ':face-pink-tears: Tears of joy here',
  'This stream is incredible :awesome:',
  'Hydration break everyone! :hydrate:',
  ':text-green-game-over: You won this!',
  ":face-blue-star-eyes: You're a star!",
  'Virtual hug for everyone :virtualhug:',
  'Happy to be here! :face-green-smiling:',
  'Chilling with my dog :chillwdog: vibing',
  ':face-red-heart-shape: Love what you do',
  ':person-turqouise-waving: Hey everyone!',
  'This community is the best! :goodvibes:',
  ':face-blue-smiling: Amazing vibes today',
  ':goodvibes: Only good vibes in this chat',
  ':body-blue-raised-arms: Victory is ours!',
  ':pride-flower-rainbow-heart: Love is love',
  ':octopus-red-waving: Waves from the chat!',
  ':thanksdoc: Thanks for the entertainment!',
  ':face-purple-crying: Why is this so good??',
  ':eyes-pink-heart-shape: Beautiful gameplay',
  ':fish-orange-wide-eyes: Eyes on the prize!',
  ':whistle-red-blow: That was a performance!',
  'Respect the grind :hand-green-crystal-ball:',
  'Learning so much from this stream :learning:',
  ':pride-people-embracing-two: Community love!',
  ':face-red-droopy-eyes: long day but worth it',
  'Chilling with my cat :chillwcat: so peaceful',
  ':face-fuchsia-tongue-out: Having too much fun',
  ':person-purple-stage-event: This is showtime!',
  ':card-red-penalty: That was risky! Bold move!',
  ':face-purple-smiling-tears: This is too good!',
  ':face-orange-tv-shape: Broadcasting excellence',
  ':face-orange-tv-shape: Broadcasting excellence',
  ':face-blue-heart-eyes: This stream has my heart',
  ':person-turquoise-crowd-surf: Crowd going wild!',
  'Best gaming session ever :trophy-yellow-smiling:',
  ':hand-purple-blue-peace: Peace out, great stream!',
  ':face-purple-sweating: Clutch moment! So intense!',
  ":hand-orange-covering-eyes: Can't believe my eyes!",
  ':face-blue-question-mark: How do you even do that?',
  ':baseball-white-cap-out: Home run! Total knockout!',
  ':volcano-green-lava-orange: Things are getting HOT',
  ':face-purple-smiling-fangs: Evil laugh at that play',
  ':stopwatch-blue-hand-timer: Speedrunning like a pro',
  ':location-yellow-teal-bars: Streaming from the top!',
  ":face-purple-open-box: What's next? More surprises?",
  ':person-turquoise-wizard-wand: Like magic out there!',
  ':face-blue-wide-eyes: Did that actually just happen?!',
  ':medal-yellow-first-red: Number one stream right here',
  ':face-turquoise-music-note: Vibing to this soundtrack',
  'Can we just appreciate how awesome this is? :awesome:',
  ':popcorn-yellow-striped-smile: This is the main event!',
  ':face-orange-raised-eyebrow: Interesting strategy there',
  ":person-blue-speaking-microphone: Let's go! Hype it up!",
  ':pride-megaphone-rainbow-handle: Amplifying good vibes!',
  ":rocket-red-countdown-liftoff: Let's go! Time to launch!",
  ':person-blue-holding-pencil: Taking notes on these skills',
  ':face-fuchsia-poop-shape: That was a mess! But we survived',
  ':person-pink-swaying-hair: The style, the skill, everything!',
  ':body-turquoise-yoga-pose: So smooth and calm under pressure',
  ':penguin-blue-waving-tear: Goodbye for now, fantastic stream!',
  ':face-turquoise-covering-eyes: Wait what? How did you do that?',
  ':face-turquoise-covering-eyes: Wait what? How did you do that?',
  ':clock-turquoise-looking-up: What time is it? Time to watch you!',
  ':person-blue-eating-spaghetti: Fueling up after that performance',
  ":hourglass-purple-sand-orange: Time flies when you're having fun",
  ':face-turquoise-drinking-coffee: Coffee and gaming, perfect combo',
  ":person-turquoise-writes-headphones: That's some creative strategy",
  ':face-purple-rain-drops: Emotional over here :face-pink-drinking-tea:',
  ':pride-person-heart-lesbian: Proud and here :pride-flowers-turquoise-transgender:',
];

export const normal_messages = [
  'GG!',
  'Wow just wow',
  'Fire fire fire',
  'Simply amazing',
  'Never gets old',
  'Veteran energy',
  'That was insane',
  'Hello everyone!',
  'Best moment ever',
  'Love seeing this',
  'Walking the walk',
  'Cannot look away',
  'Love seeing this',
  'Never disappoints',
  'What a turnaround',
  'Never counted out',
  'Respect the grind',
  'Never disappoints',
  'Respect the grind',
  'Hard work pays off',
  'Consistency is key',
  'Art form of gaming',
  'Great gameplay btw',
  'This is next level',
  'Peak entertainment',
  'This is why I watch',
  'Real recognize real',
  'Chat is going crazy',
  'Motivation overload',
  'When it matters most',
  'Setting the bar high',
  'Different vibe today',
  'Flow state activated',
  'Comeback king energy',
  'Mind blown right now',
  'Cannot stop watching',
  'The dedication shows',
  'Vibes are immaculate',
  'Automatic excellence',
  'Always coming through',
  'Unmatched performance',
  'Promises and delivers',
  'Mental game is strong',
  'Calculated every move',
  'One step ahead always',
  'Heart racing right now',
  'On the edge of my seat',
  'In the zone completely',
  'Next level inspiration',
  'From behind to victory',
  'Confidence is key here',
  'This is playoff energy',
  'I love this community!',
  'So satisfying to watch',
  'Pure talent right here',
  'Clutch moment incoming',
  'This is peak streaming',
  'Delivers under pressure',
  'Ice in the veins moment',
  'This stream is amazing!',
  'So composed and focused',
  'Muscle memory is insane',
  'Gonna apply this myself',
  'Backing it up every time',
  'Every stream gets better',
  'Good energy in this chat',
  'Physical and mental peak',
  'Tournament mode activated',
  'Absolute unit of a player',
  'Playing 4D chess out here',
  'This is pure content gold',
  'Always believes in the win',
  'Champion mentality showing',
  'Winners mindset on display',
  'This deserves all the hype',
  'Community makes it special',
  'Red pilled and game pilled',
  'Experience matters so much',
  'Been perfecting this craft',
  'Masterclass happening live',
  'First time here, loving it!',
  'Bringing the A game tonight',
  'Nothing stops this momentum',
  'Outsmarting the competition',
  'This chat is moving so fast!',
  'Incredible skills on display',
  'Years of practice paying off',
  'The way they handle pressure',
  'Unstoppable force on display',
  'Precision and power combined',
  'Nothing can break this focus',
  'This is beautiful to witness',
  'Vision and execution perfect',
  'Can we get some hype in chat?',
  'Taking mental notes right now',
  'Stealing all these strategies',
  'Absolutely crushing it today!',
  'POG! POG! POG! This is insane!',
  'Just got here, what did I miss?',
  'Showing everyone how it is done',
  'Knowledge translation to action',
  'Learning from the absolute best',
  'Stream quality is insane today!',
  'Not gonna lie, that was genius!',
  'Gaming at its finest right here',
  'Best stream on Twitch right now!',
  "The strategy here is chef's kiss",
  'This is what greatness looks like',
  'Going to bed, good night everyone!',
  'Content like this is why I tune in',
  'Clap clap clap! Amazing performance!',
  'Absolutely phenomenal content today!',
  'Respect to the dedication shown here',
  "I'm taking notes for my own gameplay",
  'Legendary session right here, no cap',
  'The mechanics on display here are unreal',
  'This is what peak performance looks like',
  'This is why I love this community so much',
  'Setting records and breaking expectations',
  "First time watching and I'm already hooked",
  'Every single play is calculated perfection',
  'The game knowledge displayed here is insane',
  'The fundamentals here are next level perfect',
  'Watching someone who truly loves their craft',
  'The way they handle adversity is so inspiring',
  'Every single decision is calculated perfectly',
  'The combination of speed and accuracy is wild',
  'This is what happens when talent meets effort',
  'The artistry in gameplay displayed right here',
  'Stream just made my day a million times better',
  'This level of consistency is absolutely insane',
  'The decision making under pressure is flawless',
  'The improvement from stream to stream is crazy',
  'The mental fortitude required for this is huge',
  'Reading opponents like they are so predictable',
  'How many years did it take to reach this level?',
  'This person has transcended normal skill levels',
  'The ability to stay cool under extreme pressure',
  'Been here since the beginning, never looked back',
  'Never seen a player adapt so quickly to mistakes',
  'This is exactly what peak performance looks like',
  'Years of training visible in every single moment',
  'Professional level execution on full display here',
  'This is the standard that everyone should aspire to',
  'Nothing phases this player when the stakes are high',
  'This is entertainment at the absolute highest level',
];

export const messages = [...twitch_messages, ...youtube_messages, ...normal_messages];
